export const tweetsRenderList = [
  { key: 'view', text: 'Views' },
  { key: 'tweets_retweet', text: 'Share-2' },
  { key: 'tweets_like', text: 'Like' },
  { key: 'tweets_reply', text: 'Comment' },
];

export const sentimentRenderList: {
  key: 'good_review' | 'bad_review' | 'neutral_review';
  icon: string;
}[] = [
  { key: 'good_review', icon: 'laugh-green-color' },
  { key: 'bad_review', icon: 'laugh-red-color' },
  { key: 'neutral_review', icon: 'laugh-grey-color' },
];

export const sentimentTypeMap: { [key: string]: string } = {
  0: 'face-question',
  1: 'laugh-red-color',
  3: 'laugh-grey-color',
  5: 'laugh-green-color',
};
